import { TFunction } from "i18next";
import { z } from "zod";

export const getControlEquipmentFormSchema = (t: TFunction) => {
  return z.object({
    equipmentType: z.string().nullable().optional(),
    equipmentBrandId: z.number().nullable().optional(),
    equipmentModel: z.string().nullable().optional(),
    specs: z.string().nullable().optional(),
    installationDate: z.string().nullable().optional(),
    removalDate: z.string().nullable().optional(),
  });
};

export type ControlEquipmentForm = z.infer<ReturnType<typeof getControlEquipmentFormSchema>>;